import React from "react";

const Java_contains = () => {
  return (
    <div>
      <h1>Java contains</h1>
      <p>This page provides explanations, examples, and common use-cases for Java contains in Java.</p>
    </div>
  );
};

export default Java_contains;
